// Mirrors the server's conservative OpenAI Chat Completions policy.
export function isChatModel(provider: string, model: string): boolean {
  if (provider.toLowerCase() !== "openai") return true;
  const id = model.trim().toLowerCase();
  if (["audio", "realtime", "transcrib", "tts", "image", "embedding", "moderation",
    "instruct", "codex", "search", "deep-research", "-pro"].some(x => id.includes(x))) return false;
  return ["gpt-3.5-turbo", "gpt-4", "gpt-4o", "gpt-4.1", "gpt-4.5", "gpt-5",
    "gpt-5.1", "gpt-5.2", "o1", "o3", "o4-mini", "chatgpt-4o-latest"]
    .some(family => id === family || id.startsWith(`${family}-`));
}
